export default __webpack_public_path__ + "static/1inch-exchange-0111622a430deaae6b7388b842e6ca7d.png";